import { Parking } from '../Model/Parking';
export class ParkingService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async saveParking(parking) {
        if (parking) {
            const response = await this.apiService.post('parking', parking);
            if (!response.ok) {
                throw new Error(`Error al guardar el parking.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async endToParking(parkingId) {
        if (parkingId) {
            const response = await this.apiService.get('parking-leave/' + parkingId);
            if (!response.ok) {
                throw new Error(`Error al guardar el parking.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async getParking(parkingId) {
        const response = await this.apiService.get('parking/' + parkingId);
        if (!response.ok) {
            throw new Error(`Error al obtener el parking.`);
        }
        const content = await response.json();
        return content;
    }
    async getParkingActiveByClientId(clientId) {
        const response = await this.apiService.get('parking-by-client/' + clientId);
        if (!response.ok) {
            throw new Error(`Error al obtener el parking.`);
        }
        const content = await response.json();
        return content ? content : null;
    }
    async getParkinsgByPlate(plate) {
        const response = await this.apiService.get('parking-plate/' + plate);
        if (!response.ok) {
            throw new Error(`Error al obtener el parking.`);
        }
        const content = await response.json();
        if (content.length == 0)
            return [];
        const parkings = content.map(p => new Parking(p.id, p.clientId, p.plate, p.zoneId, p.email, p.parkingDate, p.contactPhone, p.coords));
        return parkings;
    }
    async getParkingByClientId(clientId) {
        const response = await this.apiService.get('parking-client/' + clientId);
        if (!response.ok) {
            throw new Error(`Error al obtener el parking.`);
        }
        const content = await response.json();
        return content;
    }
}
